class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((type, event) => {
      this.onSubmitHandler(event, type);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this, 'facets'));
    // price range filter
    if (this.querySelector('form .range__field'))
      this.querySelector('form .range__field').addEventListener('priceRange', this.debouncedOnSubmit.bind(this, 'facets'));
    const collectionTitles = this.querySelectorAll('form .collection__title');
    if (collectionTitles.length > 0) {
      collectionTitles.forEach(element => {
        element.addEventListener('click', (event) => {
          // Trigger the submission
          this.debouncedOnSubmit('collection', event);

          // Update UI state
          let collectionId = element.getAttribute('data-collection-id');
          let collectionHandle = element.getAttribute('data-collection-handle');
          window.collection['id'] = collectionId;
          window.collection['handle'] = collectionHandle;

          // remove active collection
          collectionTitles.forEach(el => el.classList.remove('is-active-collection'));

          // update products based on collection name
          element.classList.add('is-active-collection');
          if (document.querySelectorAll(`form .collection__title[data-url="${element.dataset.url}"]`)) {
            document.querySelectorAll(`form .collection__title[data-url="${element.dataset.url}"]`).forEach(item => {
              item.classList.add('is-active-collection');
            })
          }
          window.scrollTo(0, 0);
        });
      });
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    // on refresh setup price range values
    let urlString = window.location.href,
      url = new URL(urlString),
      maxPrice = url.searchParams.get("filter.v.price.lte"),
      minPrice = url.searchParams.get("filter.v.price.gte");
    FacetFiltersForm.setUpPriceRange(minPrice, maxPrice);
    // FacetFiltersForm.renderAllowedCollections(document);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static setUpPriceRange(minPrice, maxPrice) {
    let rangeSliderElement = document.querySelector('#range-slider-example'),
      rangeSliderMobile = document.querySelector('#range-slider-example-mobile'),
      desktopRangeParent = document.getElementById('FacetFiltersForm'),
      mobileRangeParent = document.getElementById('FacetFiltersFormMobile');
    if (desktopRangeParent) {
      FacetFiltersForm.rangeSliderElementCreate(rangeSliderElement, minPrice, maxPrice, desktopRangeParent);
    }
    if (mobileRangeParent) {
      FacetFiltersForm.rangeSliderElementCreate(rangeSliderMobile, minPrice, maxPrice, mobileRangeParent);
    }
  }

  static rangeSliderElementCreate(selector, minPrice, maxPrice, parent) {
    let minValue = minPrice !== null && minPrice !== undefined ? minPrice : window.priceRanges.min,
      maxValue = maxPrice !== null && maxPrice !== undefined ? maxPrice : window.priceRanges.max,
      minValueText = parent.querySelector('.range-min-value span'),
      maxValueText = parent.querySelector('.range-max-value span');
    if (minValueText) minValueText.innerHTML = minValue;
    if (maxValueText) maxValueText.innerHTML = maxValue;

    if (selector) rangeSlider(selector, {
      // min value
      min: window.priceRanges.min,
      // max value
      max: window.priceRanges.max,

      // step size
      step: 5,
      // initial values
      value: [minValue, maxValue],
      // disable the range slider element
      disabled: false,
      // disable the range slider
      rangeSlideDisabled: false,
      // disable left/right (top/bottom) thumbs
      thumbsDisabled: [false, false],
      // or 'vertical'
      orientation: 'horizontal',
      // callback function
      onInput: function (valueSet) {
        let numberS = parent.querySelectorAll('.range__field'),
          minValueText = parent.querySelector('.range-min-value span'),
          maxValueText = parent.querySelector('.range-max-value span');

        numberS[0].value = valueSet[0];
        numberS[1].value = valueSet[1];
        minValueText.innerHTML = valueSet[0];
        maxValueText.innerHTML = valueSet[1];
        numberS[0].dispatchEvent(new Event('priceRange'))
        numberS[1].dispatchEvent(new Event('priceRange'))
      },
    })
  }

  static renderPage(searchParams, event, updateURLHash = true,
    lowPrice, highPrice, type = "facets") {
    let facetsFooter = document.querySelector('.mobile-facets__footer'),
      activeFacetsWrapper = document.querySelector('#active-facets-container');

    const searchParamsObj = new URLSearchParams(searchParams);
    const activeLow = searchParamsObj.get("filter.v.price.gte");
    const activeHigh = searchParamsObj.get("filter.v.price.lte");

    // Use current URL values if they exist, otherwise fallback to passed values or defaults
    const finalLow = activeLow !== null ? activeLow : (lowPrice !== undefined && lowPrice !== null ? lowPrice : window.priceRanges.min);
    const finalHigh = activeHigh !== null ? activeHigh : (highPrice !== undefined && highPrice !== null ? highPrice : window.priceRanges.max);
    if (facetsFooter) {
      facetsFooter.style.display = 'flex';
    }
    if (activeFacetsWrapper && !activeFacetsWrapper.classList.contains('active-facets--displayed')) {
      activeFacetsWrapper.classList.add('active-facets--displayed');
    }

    FacetFiltersForm.searchParamsPrev = searchParams;
    // Only the newest request may render, so a slow older response cannot overwrite it.
    const requestId = ++FacetFiltersForm.requestId;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams, type, (type === 'collection' ? event.target.dataset.url : ''));

    sections.forEach((section) => {
      if (section.section) {
        let url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        if (type === 'collection') {
          url = `${event.target.dataset.url}?section_id=${section.section}&${searchParams}`;
        }
        const filterDataUrl = (element) => element.url === url;

        FacetFiltersForm.filterData.some(filterDataUrl)
          ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, section.type, url, finalLow, finalHigh)
          : FacetFiltersForm.renderSectionFromFetch(url, event, section.type, finalLow, finalHigh, requestId);
      }
    });
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

  }

  static renderSectionFromFetch(url, event, type, lowPrice, highPrice, requestId) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        if (requestId !== FacetFiltersForm.requestId) return;
        if (type === 'product') {
          FacetFiltersForm.renderFilters(html, event, lowPrice, highPrice);
          FacetFiltersForm.renderProductGridContainer(html);
        } else if (type === 'slideshow') {
          FacetFiltersForm.renderProductGridSlideshow(html);
        } else if (type === 'faq-section') {
          FacetFiltersForm.renderProductGridFAQ(html);
        }
        else if (type === 'active-facets-container') {
          FacetFiltersForm.renderActiveFacetsContainer(html);
        } else {
          FacetFiltersForm.renderProductGridBanner(html);
        }
      }).catch((e) => {
        console.error(e);
      });
  }

  static renderActiveFacetsContainer(html) {
    const htmlDom = new DOMParser().parseFromString(html, 'text/html');
    const newActiveFilters = htmlDom.getElementById('active-facets-container');
    const currentActiveFilters = document.getElementById('active-facets-container');
    if (newActiveFilters && currentActiveFilters) {
      currentActiveFilters.innerHTML = newActiveFilters.innerHTML;
    }
  }

  static renderSectionFromCache(filterDataUrl, event, type, url, lowPrice, highPrice) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    if (type === 'product') {
      FacetFiltersForm.renderFilters(html, event, lowPrice, highPrice);
      FacetFiltersForm.renderProductGridContainer(html);
    } else if (type === 'slideshow') {
      FacetFiltersForm.renderProductGridSlideshow(html);
    } else if (type === 'faq-section') {
      FacetFiltersForm.renderProductGridFAQ(html);
    } else {
      FacetFiltersForm.renderProductGridBanner(html);
    }
  }

  static renderProductGridContainer(html) {
    const newHtmlDom = new DOMParser().parseFromString(html, 'text/html');
    const newContainer = newHtmlDom.getElementById('ProductGridContainer');
    const currentContainer = document.getElementById('ProductGridContainer');

    if (newContainer && currentContainer) {
      // If the facet form is inside the product grid container, we should only update the product list parts
      // to avoid destroying the facet form state and event listeners.
      const facetForm = currentContainer.querySelector('facet-filters-form');

      if (facetForm) {
        // Update only specific parts like the collection list and pagination
        const newCollection = newContainer.querySelector('.collection');
        const currentCollection = currentContainer.querySelector('.collection');
        if (newCollection && currentCollection) {
          currentCollection.innerHTML = newCollection.innerHTML;
          currentCollection.classList.remove('loading');
        }
      } else {
        currentContainer.innerHTML = newContainer.innerHTML;
      }
    }

    const currentCollection = currentContainer?.querySelector('.collection');
    if (currentCollection) {
      currentCollection.classList.remove('loading');
    }

    if (typeof loadProducts === "function") {
      loadProducts();
    }
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

  }

  static renderProductGridSlideshow(html) {
    if (document.getElementById('slideshow'))
      document.getElementById('slideshow').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('slideshow').innerHTML;
  }

  static renderProductGridFAQ(html) {
    if (document.getElementById('faq-section'))
      document.getElementById('faq-section').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('faq-section').innerHTML;
  }
  // static renderProductGridBanner(html) {
  //   if(document.getElementById('main-collection-banner')){
  //     document.getElementById('main-collection-banner').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('main-collection-banner').innerHTML;}
  // }

  static renderProductGridBanner(html) {
    if (document.getElementById('main-collection-banner')) {
      const newMainCollectionBanner = new DOMParser().parseFromString(html, 'text/html').getElementById('main-collection-banner');
      // Some section responses omit the banner, so guard the replacement.
      if (newMainCollectionBanner) {
        document.getElementById('main-collection-banner').innerHTML = newMainCollectionBanner.innerHTML;
      }
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event, lowPrice, highPrice) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const updateFilterGroup = (source, target, isMobile = false) => {
      const activeFilter = event ? event.target.closest('.js-filter') : null;
      const activeIndex = activeFilter ? activeFilter.dataset.index : null;

      const sourceFilters = source.querySelectorAll('.js-filter');
      const targetFilters = target.querySelectorAll('.js-filter');

      sourceFilters.forEach((sourceFilter, index) => {
        const targetFilter = targetFilters[index];
        if (!targetFilter) {
          target.appendChild(sourceFilter);
          return;
        }

        // If this is the group being interacted with, only update summary chips and list content
        // to keep the dropdown open and checkboxes focused.
        if (sourceFilter.dataset.index === activeIndex) {
          FacetFiltersForm.updateSummaryActiveFacets(sourceFilter, targetFilter);

          const sourceDisplay = sourceFilter.querySelector('.facets__display');
          const targetDisplay = targetFilter.querySelector('.facets__display');
          if (sourceDisplay && targetDisplay) {
            targetDisplay.innerHTML = sourceDisplay.innerHTML;
          }
        } else {
          // For other groups, replace the whole thing to sync counts/status
          targetFilter.replaceWith(sourceFilter);
        }
      });

      // Remove any extra filters that no longer exist in the response
      if (targetFilters.length > sourceFilters.length) {
        for (let i = sourceFilters.length; i < targetFilters.length; i++) {
          targetFilters[i].remove();
        }
      }
    };

    const desktopContainer = document.querySelector('#facets__container');
    if (desktopContainer && parsedHTML.querySelector('#facets__container')) {
      updateFilterGroup(parsedHTML.querySelector('#facets__container'), desktopContainer);
    }

    const mobileContainer = document.querySelector('#facets__container_mobile');
    if (mobileContainer && parsedHTML.querySelector('#facets__container_mobile')) {
      updateFilterGroup(parsedHTML.querySelector('#facets__container_mobile'), mobileContainer, true);
    }

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    // Re-initialize price range slider after filters are updated
    FacetFiltersForm.setUpPriceRange(lowPrice, highPrice);

    // Re-bind priceRange event listeners
    const facetForm = document.querySelector('facet-filters-form');
    const facetFormMobile = document.querySelector('facet-filters-form.facet-filters-form-mobile');

    if (facetForm && facetForm.querySelector('form .range__field')) {
      facetForm
        .querySelector('form .range__field')
        .addEventListener('priceRange', facetForm.debouncedOnSubmit.bind(facetForm, 'facets'));
    }

    if (facetFormMobile?.querySelector('form .range__field')) {
      facetFormMobile
        .querySelector('form .range__field')
        .addEventListener('priceRange', facetFormMobile.debouncedOnSubmit.bind(facetFormMobile, 'facets'));
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const currentElement = document.querySelector(selector);
      if (!activeFacetsElement || !currentElement) return;
      currentElement.innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const selectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting', '#FacetsTitleDesktop', '.mobile-facets__apply-count', '#PromotedFilterButtons'];

    selectors.forEach((selector) => {
      const source = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (source && target) {
        target.innerHTML = source.innerHTML;
      }
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm) {
      mobileForm.closest('menu-drawer').bindEvents();
    }
  }

  static renderAllowedCollections(html) {
    let collectionFilters = document.querySelectorAll('.collection-filters__wrapper .collection__title[data-selected-collection]'),
      products = html.querySelectorAll('#product-grid .grid__item');

    if (FacetFiltersForm.searchParamsPrev.trim() != ''
      && FacetFiltersForm.searchParamsPrev.includes('&')) {
      if (collectionFilters) {
        collectionFilters.forEach((filter) => {
          let collectExist = false;
          for (let i = 0; i < products.length; i++) {
            if (products[i].dataset.collectionsUrls.includes(filter.dataset.url)) {
              collectExist = true;
              break;
            }
          }
          if (!collectExist) {
            if (!filter.classList.contains('is-disabled')) {
              filter.classList.add('is-disabled');
            }
          }

        });
      }
    } else {
      if (collectionFilters) {
        collectionFilters.forEach((filter) => {
          if (filter.classList.contains('is-disabled')) {
            filter.classList.remove('is-disabled');
          }
        });
      }
    }
  }

  static updateSummaryActiveFacets(source, target) {
    const selectors = ['.active-facets-summary', '.facets__selected'];
    selectors.forEach(selector => {
      const sourceEl = source.querySelector(selector);
      const targetEl = target.querySelector(selector);
      if (sourceEl && targetEl) {
        targetEl.innerHTML = sourceEl.innerHTML;
      }
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams, type = 'facets', collectionPath) {
    let url = window.location.pathname;
    if (type === 'collection') {
      url = collectionPath;
    }
    history.pushState({ searchParams }, '', `${url}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid')?.dataset.id,
        type: 'product'
      },
      {
        section: 'main-search',
        type: 'active-facets-container'
      },
      {
        section: document.getElementById('slideshow') ? document.getElementById('slideshow').dataset.id : '',
        type: 'slideshow'
      },
      {
        section: document.getElementById('faq-section') ? document.getElementById('faq-section').dataset.id : '',
        type: 'faq-section'
      },
      {
        section: document.getElementById('main-collection-banner') ? document.getElementById('main-collection-banner').dataset.id : '',
        type: 'main-collection-banner'
      }
    ]
  }

  onSubmitHandler(event, type) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    // don't filter prices with the default price range.
    if (String(formData.get("filter.v.price.gte")) === String(window.priceRanges.min)
      && String(formData.get("filter.v.price.lte")) === String(window.priceRanges.max)) {
      formData.delete("filter.v.price.gte");
      formData.delete("filter.v.price.lte");
    }


    // On mobile, the sorting is not part of the form, and we found that when sorting is missing, the url breaks when there is a special character in the url. Example, search by Grün and paginate and nothing works, also not on refresh.

    const existingSortBy = formData.get("sort_by");
    if (!existingSortBy) {
      const activeMobileSorting = event.target.closest('.facets-container-mobile')?.querySelector('.sort-items__option.is-active');
      if (activeMobileSorting) {
        formData.append("sort_by", activeMobileSorting.dataset.value);
      }
    }

    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event, true, formData.get("filter.v.price.gte"), formData.get("filter.v.price.lte"), type);
  }

  // A promoted button's href is rendered for the filters of the last finished response. While a
  // request is still loading, toggle its value on the newest requested filters instead, so a quick
  // second click removes the filter and a click on another button keeps the first one.
  static togglePromotedFilter(link) {
    const { filterParam, filterValue } = link.dataset;
    const searchParams = new URLSearchParams(FacetFiltersForm.searchParamsPrev);
    const values = searchParams.getAll(filterParam);
    const isActive = values.includes(filterValue);

    searchParams.delete(filterParam);
    values.filter((value) => value !== filterValue).forEach((value) => searchParams.append(filterParam, value));
    if (!isActive) searchParams.append(filterParam, filterValue);
    searchParams.delete('page');

    link.classList.toggle('is-active', !isActive);
    return searchParams.toString();
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const link = event.currentTarget;
    const url = link.dataset.filterParam
      ? FacetFiltersForm.togglePromotedFilter(link)
      : link.href.indexOf('?') == -1 ? '' : link.href.slice(link.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.requestId = 0;
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);

// document.addEventListener('DOMContentLoaded', () => {
//   // Select both mobile and desktop facet-remove elements
//   const facetRemoves = document.querySelectorAll('facet-remove');

//   facetRemoves.forEach(facetRemove => {
//     const link = facetRemove.querySelector('a');
//     if (!link) return;

//     link.addEventListener('click', (event) => {
//       event.preventDefault();

//       // Debug logging: see what was clicked
//       console.log('Direct target element:', event.target);
//       console.log('Closest facet-remove:', event.target.closest('facet-remove'));

//       // Determine container and URL
//       let containerSelector;

//       // ✅ Check for mobile clear all
//       if (facetRemove.classList.contains('mobile-facets__clear-wrapper')) {
//         containerSelector = '#facets__container_mobile'; // mobile

//       // ✅ Check for desktop clear all by finding closest container
//       } else if (facetRemove.closest('.active-facets')) {
//         containerSelector = '#FacetFiltersForm'; // desktop

//       } else {
//         console.log('Unknown facet-remove type:', facetRemove);
//         return; // unknown type, skip
//       }

//       // Build search URL from link's query params
//       const url = `/search?${link.href.split('?')[1] || ''}`;

//       fetch(url)
//         .then(response => response.text())
//         .then(htmlText => {
//           const parser = new DOMParser();
//           const htmlDoc = parser.parseFromString(htmlText, 'text/html');

//           const newFacets = htmlDoc.querySelector(containerSelector);
//           const currentFacets = document.querySelector(containerSelector);

//           if (newFacets && currentFacets) {
//             currentFacets.innerHTML = newFacets.innerHTML;
//             console.log('Facets updated for', containerSelector);

//             // Optional: re-bind click listeners for new filters
//             currentFacets.querySelectorAll('a').forEach(a => {
//               a.addEventListener('click', (e) => {
//                 e.preventDefault();
//                 // handle individual filter clicks here
//               });
//             });

//             // ✅ Update mobile filter button label
//             const newMobileFilterButton = htmlDoc.querySelector('.mobile-facets__open');
//             const currentMobileFilterButton = document.querySelector('.mobile-facets__open');
//             if (newMobileFilterButton && currentMobileFilterButton) {
//               currentMobileFilterButton.innerHTML = newMobileFilterButton.innerHTML;

//               // Remove "(X)" from label
//               const labelEl = currentMobileFilterButton.querySelector('.mobile-facets__open-label');
//               if (labelEl) {
//                 labelEl.textContent = labelEl.textContent.replace(/\(\d+\)/, '').trim();
//               }
//             }
//           }
//         })
//         .catch(err => console.error('Error fetching facets:', err));
//     });
//   });
// });
